export default __webpack_public_path__ + "static/client4-57be6ef6e35e95254c1d9ba3e09d57ac.svg";